import { AccountKind, CustomerUserDTO } from '../models/customer.model';

export function isAgentAccount(account: { kind?: AccountKind | null }): boolean {
  return account.kind === 'AGENT';
}

/** Agentenkonten zeigen ihr Kürzel; die interne Adresse `…@agent.invalid` erscheint nie in der Oberfläche. */
export function visibleAddress(user: Pick<CustomerUserDTO, 'email' | 'kind' | 'kuerzel'>): string {
  return isAgentAccount(user) ? (user.kuerzel ?? '') : user.email;
}
